import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const checkboxInputV3PaddingToMarginMigration: PropsMigration = {
  mode: 'props',
  description: 'Migrate checkbox external spacing from offset.padding to offset.margin',
  run: (props: PartialPropsOf<'checkboxInput'>): void => {
    const offset = props.style?.general?.offset;
    if (offset?.padding === undefined) {
      return;
    }
    offset.margin = offset.padding;
    delete offset.padding;
  },
};
